(function (global) {
  "use strict";

  var valueRef = null;
  var optionsRef = null;
  var hiddenInput = null;
  var pendingOptions = null;
  var bootAttempts = 0;
  var MAX_BOOT_ATTEMPTS = 40;

  function toSelectOptions(items) {
    return (items || [])
      .filter(function (item) {
        return item && item.identity;
      })
      .map(function (item) {
        var label = String(item.identity).trim();
        return { value: label, label: label };
      });
  }

  function dependenciesReady() {
    return Boolean(global.Vue && global.antd && global.antd.Select);
  }

  function applyOptions(options) {
    if (optionsRef) {
      optionsRef.value = options;
      pendingOptions = null;
      return;
    }
    pendingOptions = options;
  }

  function mountIdentitySelect(form) {
    var mountEl = form.querySelector(".beyke-ant-identity-field");
    hiddenInput = form.querySelector('input[type="hidden"][name="status"]');
    if (!mountEl || !hiddenInput || mountEl.__beykeIdentitySelectMounted) return false;

    var Vue = global.Vue;
    var antd = global.antd;
    var h = Vue.h;
    var locale = antd.enUS || (antd.locale && antd.locale.enUS);
    var placeholder = mountEl.getAttribute("data-placeholder") || "Select your role";

    mountEl.__beykeIdentitySelectMounted = true;

    var app = Vue.createApp({
      setup: function () {
        valueRef = Vue.ref(undefined);
        optionsRef = Vue.ref(pendingOptions || []);

        Vue.watch(valueRef, function (next) {
          hiddenInput.value = next || "";
        });

        if (pendingOptions) {
          pendingOptions = null;
        }

        return function () {
          var select = h(antd.Select, {
            value: valueRef.value,
            "onUpdate:value": function (next) {
              valueRef.value = next;
            },
            options: optionsRef.value,
            placeholder: placeholder,
            allowClear: true,
            dropdownClassName: "beyke-inquiry-select",
            getPopupContainer: function () {
              return document.getElementById("contact-form") || mountEl;
            },
            style: { width: "100%" },
          });

          if (!locale) return select;

          return h(antd.ConfigProvider, { locale: locale, theme: { primaryColor: "#6f9327" } }, function () {
            return select;
          });
        };
      },
    });

    app.use(antd);
    app.mount(mountEl);
    return true;
  }

  global.BeykeContactIdentitySelect = {
    setOptions: function (items) {
      applyOptions(toSelectOptions(items));
    },
    reset: function () {
      try {
        if (valueRef) valueRef.value = undefined;
      } catch (error) {
        /* keep going */
      }
      if (hiddenInput) hiddenInput.value = "";
    },
  };

  function boot() {
    var form = document.getElementById("beyke-contact-form");
    if (form && dependenciesReady() && mountIdentitySelect(form)) return;

    bootAttempts += 1;
    if (bootAttempts < MAX_BOOT_ATTEMPTS) {
      global.setTimeout(boot, 100);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})(window);
